export interface Testimonial {
  name: string
  detail: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Megan Whitaker, 34',
    detail: 'Stay-at-home mom — Leeds, United Kingdom',
    quote:
      "I had a folder full of saved recipes and never sold a single roll. What changed for me was the dough module — I finally understood how the dough should feel and look instead of guessing. Three weeks later I was taking weekend orders from school parents, and every batch comes out the same now.",
  },
  {
    name: 'Danielle Rivera, 41',
    detail: 'Part-time nurse — Phoenix, Arizona, United States',
    quote:
      "My rolls tasted good but always looked homemade. The frosting and presentation module was the difference. Cleaner spirals, consistent glaze, proper boxes — people started asking the price before I even offered. I sell two trays every Saturday alongside my shifts.",
  },
  {
    name: 'Priya Nair, 29',
    detail: 'Home baker — Mississauga, Ontario, Canada',
    quote:
      "The flavor formulas alone were worth it. I went from one plain cinnamon roll to six options — caramel pecan, coffee maple and chocolate are my best sellers. Having a menu made me feel like I actually had a product instead of a hobby.",
  },
  {
    name: 'Sophie Bennett, 47',
    detail: 'Former office admin — Brisbane, Australia',
    quote:
      "Batch production was my wall. I could make eight rolls, not forty. The prep system taught me how to time fermentation and manage the oven so I can now run a proper order day without chaos in my kitchen. I finally feel organized.",
  },
  {
    name: 'Hannah Clarke, 38',
    detail: 'Mom of three — Manchester, United Kingdom',
    quote:
      "I nearly quit after a dry batch ruined an order. The troubleshooting section told me exactly what went wrong and how to correct it. That one fix saved my little business. Six months in, cinnamon rolls are a real second income for our family.",
  },
]
